"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultFilters = exports.MemberRelationship = exports.FilterGroup = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const FilterList_1 = __importDefault(require("@mui/icons-material/FilterList"));
const luxon_1 = require("luxon");
var FilterGroup;
(function (FilterGroup) {
    FilterGroup["MemberRelationship"] = "memberRelationship";
    FilterGroup["MemberEligibility"] = "memberEligibility";
})(FilterGroup = exports.FilterGroup || (exports.FilterGroup = {}));
var MemberRelationship;
(function (MemberRelationship) {
    MemberRelationship["Required"] = "Member Relationship - at least 1 required";
    MemberRelationship["Optional"] = "Member Relationship";
})(MemberRelationship = exports.MemberRelationship || (exports.MemberRelationship = {}));
const RootDiv = (0, material_1.styled)("div")({
    flexDirection: "row-reverse",
    flex: "1 1 auto",
});
const FiltersButton = (0, material_1.styled)(material_1.Button)(({ theme }) => ({
    // @ts-ignore
    color: theme?.palette?.text?.link,
    float: "right",
}));
const FiltersFormControl = (0, material_1.styled)(material_1.FormControl)(({ theme }) => ({
    margin: theme.spacing(3),
}));
const RadioGroup = (0, material_1.styled)(material_1.Checkbox)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));
exports.defaultFilters = {
    relationPCP: true,
    relationEnc: false,
    eligibilityCurrent: true,
    eligibilityPrior: false,
    eligibilityPrior2: false,
};
exports.default = ({ currentYear = luxon_1.DateTime.local().year, filters = exports.defaultFilters, memberRelationship, onChange, options = [], }) => {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleChange = (event) => {
        onChange({
            ...filters,
            [event.target.name]: event.target.checked,
        });
    };
    const checkboxGroups = [
        {
            id: FilterGroup.MemberRelationship,
            label: memberRelationship,
        },
        {
            id: FilterGroup.MemberEligibility,
            label: "Member Eligibility",
        },
    ];
    const checkboxes = [
        {
            checked: filters.relationPCP,
            value: "relationPCP",
            label: "Assigned Members (PCP)",
            group: FilterGroup.MemberRelationship,
        },
        {
            checked: filters.relationEnc,
            value: "relationEnc",
            label: "All Encountered Members",
            group: FilterGroup.MemberRelationship,
        },
        {
            checked: filters.eligibilityCurrent,
            value: "eligibilityCurrent",
            label: currentYear,
            group: FilterGroup.MemberEligibility,
        },
        {
            checked: filters.eligibilityPrior,
            value: "eligibilityPrior",
            label: currentYear - 1,
            group: FilterGroup.MemberEligibility,
        },
        {
            checked: filters.eligibilityPrior2,
            value: "eligibilityPrior2",
            label: currentYear - 2,
            group: FilterGroup.MemberEligibility,
        },
        ...options,
    ];
    return (react_1.default.createElement(RootDiv, null,
        react_1.default.createElement(FiltersButton, { startIcon: react_1.default.createElement(FilterList_1.default, null), onClick: handleClick }, "Filters"),
        react_1.default.createElement(material_1.Menu, { anchorEl: anchorEl, transformOrigin: {
                vertical: -180,
                horizontal: "center",
            }, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose },
            react_1.default.createElement(FiltersFormControl, null, checkboxGroups.map(({ id, label }) => (react_1.default.createElement("div", { key: id },
                react_1.default.createElement(material_1.FormLabel, null, label),
                react_1.default.createElement(material_1.FormGroup, null, checkboxes
                    .filter(({ group }) => group === id)
                    .map(({ value, label: checkboxLabel, checked }) => (react_1.default.createElement(material_1.FormControlLabel, { key: value, control: react_1.default.createElement(RadioGroup, { color: "primary", checked: checked, onChange: handleChange, name: value }), label: checkboxLabel })))))))))));
};
